import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'
import { Separator } from '@/components/ui/separator';


function About() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
<div className="mx-auto my-12 md:my-36 max-w-7xl px-6 font-gotham text-medium">
  <div className="flex flex-col items-center gap-10 lg:flex-row lg:items-center lg:gap-12">
    {/* IMAGE */}
    <div className="w-full lg:w-5/12">
      <img
        src="/assets/images/BMS_0753.jpg"
        alt="Footer Banner"
        className="w-full h-auto object-cover rounded-3xl aspect-square"
      />
      <p className='font-gotham text-xs p-2 px-6'>image: Blooming Moon Studio</p>
    </div>

    {/* TEXT */}
    <div className="w-full lg:flex-1 px-6 md:py-12">
      <h1 className="mb-6">I am Jo!</h1>
      <p>
      The special project I am Jo! showcases the strength and creativity of more than 100 women from Amsterdam, inspired by the story of Jo van Gogh-Bonger. She was the enterprising woman who made Vincent van Gogh world-famous.
      </p>

      {/* BUTTONS */}
      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:gap-3">
        <Link to="/en/story" className="w-full sm:w-auto">
          <Button className="w-full sm:w-auto focus:outline-none focus:ring-0 focus-visible:ring-0 text-base text-background">
            Read the story
          </Button>
        </Link>

        <Link to="/en/docu" className="w-full sm:w-auto">
          <Button className="w-full sm:w-auto focus:outline-none focus:ring-0 focus-visible:ring-0 bg-background border-2 border-black text-base text-black hover:bg-black hover:text-background hover:border-black">
            Watch the documentary
          </Button>
        </Link>
      </div>

      <Separator className="border my-12 border-black rounded" />

      {/* LOGOS */}
      <div className="flex flex-wrap gap-4 items-center justify-center lg:justify-end">
        <img
          src="/assets/logos/Van-Gogh-museum-logo.jpg"
          alt="Van Gogh Museum"
          className="h-24 sm:h-24 hover:opacity-85 mix-blend-luminosity"
        />
        <img
          src="/assets/logos/cropped-cropped-Alliantie_Logo_CMYK.png"
          alt="Alliantie"
          className="h-24 sm:h-24 hover:opacity-85 mix-blend-luminosity"
        />
      </div>
    </div>
  </div>
</div>


    </>
  );
}

export default About;